import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-admin-login',
  templateUrl: './admin-login.component.html',
  styleUrls: ['./admin-login.component.css']
})
export class AdminLoginComponent implements OnInit {

  returnUrl: string;
  loginFailed: boolean;

  credentials = {
    username: '',
    password: '',
    role: 'ROLE_ADMIN'
  };

  constructor(
    private route: ActivatedRoute,
    private authService: AuthService,
    private router: Router
  ) {
    this.loginFailed = false;
  }

  ngOnInit() {
    const returnUrl = this.route.snapshot.queryParams['returnUrl'];
    this.returnUrl = (returnUrl && returnUrl.indexOf('admin/login') !== 0 && returnUrl.indexOf('/logout') !== 0) ? returnUrl : '/';
    if (this.authService.isLoggedIn) {
      this.router.navigateByUrl(this.returnUrl);
    }
  }

  onSubmit() {
    if (this.credentials.username && this.credentials.password && this.credentials.role) {
      this.authService.login(this.credentials.username, this.credentials.password, this.credentials.role)
        .subscribe(
          result => {
            this.router.navigateByUrl(this.returnUrl);
          },
          error => {
            this.loginFailed = true;
          }
        );
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/components/admin-login/admin-login.component.ts